import { Injectable } from "@angular/core";
import { SearchGroup, Status, translateCommonErrorStatus } from "@core/data";
import { AdvancedReportCompilerService } from "@core/data/api/reports/advanced-report-compiler.service";
import { GanttComponentData } from "@core/data/types/advanced-report";
import { Characteristic } from "@library";
import { Action, Selector, State, StateContext } from "@ngxs/store";
import { tap } from "rxjs/operators";

export interface ReportGanttFormStateModel {
    key:          string;
    data:         GanttComponentData;
    status:       Status;
    reportKey:    string;
    ownerOrgKey:  string;
    dateChars:    SearchGroup<Characteristic>[];
}

const DEFAULTS: ReportGanttFormStateModel = {
    key:         null,
    data:        null,
    status:      Status.UNINITIALIZED,
    reportKey:   null,
    ownerOrgKey: null,
    dateChars:   [],
};

export class InitReportGanttForm {
    static readonly type = "[ReportGanttForm] Init";
    constructor(
        public reportKey:   string,
        public ownerOrgKey: string,
        public optionKey:   string,
        public data:        GanttComponentData,
    ) {}
}

export class LoadGanttFormOptions {
    static readonly type = "[ReportGanttForm] Load Options";
}

@State<ReportGanttFormStateModel>({
    name: 'advanced_report_gantt_form',
    defaults: DEFAULTS,
})
@Injectable()
export class ReportGanttFormState {

    @Selector()
    static dateChars(state: ReportGanttFormStateModel) {
        return state.dateChars;
    }

    constructor(private _compilerService: AdvancedReportCompilerService) {}

    @Action(InitReportGanttForm)
    init(ctx: StateContext<ReportGanttFormStateModel>, action: InitReportGanttForm) {
        ctx.setState({
            ...DEFAULTS,
            key:         action.optionKey,
            data:        action.data,
            reportKey:   action.reportKey,
            ownerOrgKey: action.ownerOrgKey,
            status:      Status.LOADING,
        });

        ctx.dispatch(new LoadGanttFormOptions());
    }

    @Action(LoadGanttFormOptions)
    loadOptions(ctx: StateContext<ReportGanttFormStateModel>) {
        const { reportKey, ownerOrgKey } = ctx.getState();

        return this._compilerService.ganttOptions(reportKey, ownerOrgKey).pipe(
            tap(
                result => ctx.patchState({ status: Status.OK, dateChars: result.characteristics || [] }),
                error  => ctx.patchState({ status: translateCommonErrorStatus(error), dateChars: [] }),
            )
        );
    }
}
